import { Icon } from "@material-ui/core";
import Card from "components/UI/Card/Card";
import CardBody from "components/UI/Card/CardBody";
import CardHeader from "components/UI/Card/CardHeader";
import CardIcon from "components/UI/Card/CardIcon";
import Button from "components/Forms/CustomButtons/Button";
import GridContainer from "components/UI/Grid/GridContainer";
import GridItem from "components/UI/Grid/GridItem";
import Table from "components/Tables/Table/Table";
import Skeleton from "react-loading-skeleton";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);

export default function LastAnalysis({
  homologated = false,
  processLoading = false,
  processes,
  onReload,
  size = 6,
}) {
  const classes = useStyles();

  const cardDetails = homologated
    ? { color: "success", header: "Últimas análisis aprobados" }
    : { color: "danger", header: "Últimas análisis rechazado" };

  const showProcesses = () => {
    if (processLoading) {
      return [
        [<Skeleton key={0} />, <Skeleton key={1} />, <Skeleton key={2} />],
      ];
    }

    if (processes.length > 0) {
      return processes;
    }

    return [["No hay un proceso finalizado", "", ""]];
  };

  return (
    <GridItem xs={size}>
      <Card>
        <CardHeader color={cardDetails.color} icon>
          <CardIcon color={cardDetails.color}>
            <Icon>search</Icon>
          </CardIcon>
          <h4 className={classes.cardIconTitle}>{cardDetails.header}</h4>
        </CardHeader>
        <CardBody>
          <GridContainer justify="space-between">
            <GridItem xs={12} sm={12} md={12}>
              <Table tableData={showProcesses(processes)} />
            </GridItem>
          </GridContainer>
        </CardBody>
      </Card>
    </GridItem>
  );
}
